import { Plus } from 'lucide-react';
import React from 'react';
import { Button } from '../../../components/ui/button';
import { SyncTemplatesButton } from './SyncTemplatesButton';
import styles from './EngageAutomationsTab.module.css';

interface TemplatesTableControlsProps {
  onCreateTemplate: () => void;
}

export const TemplatesTableControls: React.FC<TemplatesTableControlsProps> = ({
  onCreateTemplate,
}) => {
  return (
    <>
      <SyncTemplatesButton />
      <Button onClick={onCreateTemplate} className={styles.newTemplateButton}>
        <Plus className={styles.icon} />
        New Automation
      </Button>
    </>
  );
};
